import { useCallback, useEffect, useRef } from 'react';

import {
  RESULT_DWELL_MS,
  RESULT_TABS_VIEWED,
  markPromptEligible,
} from '../../core';

import type { MetricTabId } from './resultCopy';

/**
 * 결과 화면을 **들여다봤는지** 잰다 — 홈의 의견 남기기 팝업이 누구에게 뜰지의 근거다
 * (`core/feedbackPrompt`). 10초 이상 머물렀거나 지표 탭을 서로 다른 둘 이상 눌렀으면
 * 자격을 적는다.
 *
 * 조건이 **선 순간** 적는다. 나갈 때 적으면 앱을 내리거나 새로고침으로 떠난 사람을 놓친다.
 *
 * 돌려주는 함수는 탭을 누를 때마다 부른다. `enabled` 가 false 면 아무것도 재지 않는다 —
 * 대상은 첫 진단의 결과뿐이다(호출부가 정한다).
 */
export const useResultEngagement = (
  enabled: boolean,
): ((tab: MetricTabId) => void) => {
  const viewed = useRef(new Set<MetricTabId>());

  useEffect(() => {
    if (!enabled) {
      return;
    }
    const timer = window.setTimeout(markPromptEligible, RESULT_DWELL_MS);
    return () => window.clearTimeout(timer);
  }, [enabled]);

  return useCallback(
    (tab: MetricTabId) => {
      if (!enabled) {
        return;
      }
      viewed.current.add(tab);
      if (viewed.current.size >= RESULT_TABS_VIEWED) {
        markPromptEligible();
      }
    },
    [enabled],
  );
};
